import { useState } from "react";
import { datePrecision, type DatePrecision } from "../utils/partialDate";

/** Unknown components stay empty; increasing precision never supplies a month or day. */
export function usePartialDate(value: string | null, onChange: (value: string | null) => void) {
  const [emptyPrecision, setEmptyPrecision] = useState<DatePrecision>(value ? datePrecision(value) : "day");
  const precision = value ? datePrecision(value) : emptyPrecision;
  const parts = (value ?? "").split("-");
  const write = (next: string[], selected: DatePrecision) => {
    const count = selected === "year" ? 1 : selected === "month" ? 2 : 3;
    const included = Array.from({ length: count }, (_, index) => next[index] ?? "");
    onChange(included.every(part => !part) ? null : included.join("-"));
  };
  return {
    precision, year: parts[0] ?? "", month: parts[1] ?? "", day: parts[2] ?? "",
    selectPrecision: (next: DatePrecision) => { setEmptyPrecision(next); write(parts, next); },
    changePart: (index: number, next: string) => {
      const changed = [...parts]; changed[index] = next; write(changed, precision);
    },
    clear: () => onChange(null),
  };
}
